import $ = require("jquery");
import Base = require("./base-command");

/**
 * Performs DOM manipulations, used by the search tool to update the search content:
 *  $(selector).val(value)
 *
 */
class Command extends Base<any> {
    static about = `
facilitates modifying input elements and can be used to put values on the args stack
    `;

    static input = {
        "value": "the new value",
        "selector": "css selector to find the target elements"
    };

    static output = {
        "type": "change",
        "original": "the value before applying the change",
        "value": "the current value"
    }

    execute(args: any = this.args) {

        let value = this.findOption("value");
        let selector = this.findOption("selector");

        let oldValue = $(selector).val();

        if (typeof value === "string") {
            $(selector).val(value).change();
        }

        this.trigger({
            type: "change",
            original: oldValue,
            value: $(selector).val()
        });
    }

}

/** 
<EVENT about="sets the search input to whatever &quot;value&quot; is on the argument stack" event="liferay:search" id="liferay-search-handler" mid="app/commands/dom">
  <OPTIONS>
    <Values id="selector" value=".header-search-input" />
  </OPTIONS>
</EVENT>

 */
export = Command;